<template>
  <div id="app">
    <Header routeValue="1" ref="header" :productName="queryParam.productName"></Header>
    <content class="content" @mousedown="handleMouseLeave" @click="handleDel()">
      <div class="arrivals_box" v-if="productList.length>0">
        <span class="title">New Arrivals</span>
        <span class="des">Explore Printbelle's best</span>
        <div class="swiper_box">
          <swiper ref="mySwiper" :options="swiperOption">
            <swiper-slide v-for="(item,index) in productList" :key="index">
              <div class="slide_box" :data-id="item.seoCustomerAddress">
                <div class="img_box">
                  <img
                    class="img1" :src="item.productImg|imgFilter(318)">
                  <img
                    class="img2" :src="item.productTemplateImg|imgFilter(318)">
                </div>
                <span class="name">{{ item.productNameEn }}</span>
                <span class="price" v-if="false">Start from ${{ item.minPrice }}</span>
              </div>
            </swiper-slide>
          </swiper>
          <div class="button-prev">
            <img src="../assets/prev.png">
          </div>
          <div class="button-next">
            <img src="../assets/next.png">
          </div>
        </div>
      </div>
      <div class="product_box">
        <a-row>
          <a-col span="5">
            <a-menu
              style="width: 300px"
              :open-keys="openKeys"
              :default-open-keys="openKeys"
              :selectedKeys="selectedKeys"
              @openChange="onOpenChange"
              mode="inline">
              <template v-for="menu in menuData">
                <template v-if="menu.children && menu.children.length > 0">
                  <a-sub-menu :key="menu.id">
                    <div slot="title"
                         style="display: flex; align-items: center; justify-content: space-between; font-family: Roboto; font-weight: 500; font-size: 21px;"
                         @click="handleItemClick(menu.id, 0,1, menu)">
                      <span>{{ menu.name }} ({{ menu.productNumber || 0 }})</span>
                      <a-icon
                        :style="{ transform: menu.menuOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s',
                        position: 'absolute' ,right:'0px',paddingTop:'16px', fontSize:'12px',color:'#000000',width: '30px',height: '40px'}"
                        type="down">
                      </a-icon>
                    </div>
                    <template v-for="subMenu in menu.children">
                      <a-sub-menu v-if="subMenu.children && subMenu.children.length > 0" :key="subMenu.id"
                                  :style="{width:'100%',background:subMenu.submenuOpen ?'#E3E4E5':'',position: 'relative',
                                  color: subMenu.submenuOpen ?'#343183':''}">
                        <div slot="title" style="display: flex; align-items: center;padding-top: 4px;font-size: 18px"
                             @click="handleItemClick(subMenu.id,1, 2,menu)">
                          <span>{{ subMenu.name }} ({{ subMenu.productNumber || 0 }})</span>
                        </div>
                        <a-divider type="vertical" v-if="subMenu.submenuOpen"
                                   style="position: absolute;width: 3px;height: 44px; background: #343183;top: 0;right: -10px"/>
                        <a-menu-item v-for="item in subMenu.children" :key="item.id"
                                     @click="handleItemClick(item.id,1,3,menu)">
                          {{ item.name }} ({{ item.productNumber || 0 }})
                        </a-menu-item>
                      </a-sub-menu>
                      <template v-else>
                        <a-menu-item :key="subMenu.id" @click="handleItemClick(subMenu.id,1,3,menu)">
                          <span style="font-size: 18px;font-weight: 400">
                            {{ subMenu.name }} ({{ subMenu.productNumber || 0 }})
                          </span>
                        </a-menu-item>
                      </template>
                    </template>
                  </a-sub-menu>
                </template>
                <template v-else>
                  <a-menu-item :key="menu.id" style="font-family: Roboto;font-weight: 500;font-size: 21px;"
                               @click="handleItemClick(menu.id,1,1,menu)">
                    {{ menu.name }} ({{ menu.productNumber || 0 }})
                  </a-menu-item>
                </template>
              </template>
            </a-menu>
          </a-col>
          <a-col span="19">
            <div class="product_view" v-if="menuData.length>0">
              <span class="title">{{ menuTitle }}</span>
              <div class="label_box">
                <div class="label">
                  <div v-for="(item, index) in selectNames" :key="index">
                    {{ item }}
                    <span v-if="index !== selectNames.length - 1" style="margin: 0 5px">/</span>
                  </div>
                </div>
                <a-checkbox-group :value="queryParam.tagIds" class="checkbox_group">
                  <div :key="item.id" v-for="(item) in tagsList">
                    <a-checkbox :value="item.id" @change="checkBoxOnChange" class="checkbox">
                      {{ item.name }}
                    </a-checkbox>
                  </div>
                </a-checkbox-group>
              </div>
              <div class="filtrate_box">
                <div style="display: flex">
                  <a-select
                    placeholder="Price"
                    allowClear
                    v-model="priceRange"
                    @change="handleChange1($event, 0)"
                    style="width: 150px; margin-right: 10px"
                  >
                    <a-select-option
                      v-for="(item, index) in priceList"
                      :label="item.label"
                      :key="index"
                      :title="item.label"
                      :value="item.value"
                    >
                      <span v-if="selectedPrice">
                        <a-icon type="check" v-if="selectedPrice === item.value" class="check_icon"/>
                        <a-icon type="check" v-else class="check_icon" style="visibility: hidden"/>
                      </span>
                      <span class="tagName">&nbsp;&nbsp;{{ item.label }}</span>
                    </a-select-option>
                  </a-select>
                  <a-select
                    placeholder="Fulfillment Location"
                    allowClear
                    v-model="queryParam.locationId"
                    @change="handleChange1($event, 1)"
                    style="width: 200px; margin-right: 10px"
                  >
                    <a-select-option
                      v-for="(item, index) in locationList"
                      :label="item.showName"
                      :key="index"
                      :title="item.showName"
                      :value="item.id"
                    >
                      <span v-if="selectedLocation">
                        <a-icon type="check" v-if="selectedLocation === item.id" class="check_icon"/>
                        <a-icon type="check" v-else class="check_icon" style="visibility: hidden"/>
                      </span>
                      <span class="tagName">&nbsp;&nbsp;{{ item.showName }}</span>
                    </a-select-option>
                  </a-select>
                  <div @mousedown.stop="handleMouseDown($event,0)" v-if="false">
                    <a-select placeholder="Price" :open="priceOpen" v-model="priceRange" allowClear
                              @change="handleChange($event,0)"
                              style="width: 150px">
                      <div slot="dropdownRender" slot-scope="menu">
                        <div
                          style="padding: 8px;  display: flex;align-items: center;justify-content: center;line-height: 1;">
                          <a-input v-model="queryParam.minPrice" @click.stop="handleInputClick"
                                   @input="handleInput(0)" style="height: 32px"/>
                          <span style="margin: 0 3px;">-</span>
                          <a-input v-model="queryParam.maxPrice" @click.stop="handleInputClick"
                                   @input="handleInput(0)" style="height: 32px"/>
                        </div>
                      </div>
                    </a-select>
                  </div>
                  <div @mousedown.stop="handleMouseDown($event,1)" v-if="false">
                    <a-select placeholder="Weight" :open="weightOpen" v-model="weightRange"
                              allowClear @change="handleChange($event,1)"
                              style="width: 150px;margin-left: 10px">
                      <div slot="dropdownRender" slot-scope="menu">
                        <div
                          style="padding: 8px;  display: flex;align-items: center;justify-content: center;line-height: 1;">
                          <a-input v-model="queryParam.minWeight" @click.stop="handleInputClick"
                                   @input="handleInput(1)" style="height: 32px"/>
                          <span style="margin: 0 3px;">-</span>
                          <a-input v-model="queryParam.maxWeight" @click.stop="handleInputClick"
                                   @input="handleInput(1)" style="height: 32px"/>
                        </div>
                      </div>
                    </a-select>
                  </div>
                  <div @mousedown.stop="handleMouseDown($event,2)" v-if="false">
                    <a-select placeholder="Production time" :open="timeOpen" v-model="timeRange"
                              allowClear @change="handleChange($event,2)"
                              style="width: 213px;margin-left: 10px">
                      <div slot="dropdownRender" slot-scope="menu">
                        <div
                          style="padding: 8px;display: flex;align-items: center;justify-content: center;line-height: 1;">
                          <a-input v-model="queryParam.performanceTime" @click.stop="handleInputClick"
                                   @input="handleInput(2)" style="height: 32px"/>
                          <span style="margin: 0 3px;">-</span>
                          <a-input v-model="queryParam.performanceTimeEnd" @click.stop="handleInputClick"
                                   @input="handleInput(2)" style="height: 32px"/>
                        </div>
                      </div>
                    </a-select>
                  </div>
                </div>

                <a-select placeholder="Sort by" allowClear style="width: 150px;margin-left: 10px"
                          @change="handleChange($event,3)">
                  <a-select-option :value="0">
                    New arrivals
                  </a-select-option>
                  <a-select-option :value="1">
                    Price(high-low)
                  </a-select-option>
                  <a-select-option :value="2">
                    Price(low-high)
                  </a-select-option>
                </a-select>
              </div>
              <a-skeleton :loading="spinning" active :paragraph="{rows: 14}">
                <div class="product_list" v-if="dataList.length>0">
                  <div class="list_box" v-for="(item,index) in dataList" :key="index" @click="toDetailsDes(item)">
                    <div class="img_box">
                      <img
                        class="img1" :src="item.productImg|imgFilter(360)">
                      <img
                        class="img2" :src="item.productTemplateImg|imgFilter(360)">
                    </div>
                    <span class="name">{{ item.productNameEn }}</span>
                    <span class="price">From $ {{ item.minPrice }}</span>
                    <span class="size">{{ item.spec }}</span>
                    <div class="tag_box" v-if="false">
                      <img src="../assets/best@2x.png" v-if="isShowTag(item,'Bestsellers')" style="width: 74px">
                      <img src="../assets/new@2x.png" v-if="isShowTag(item,'New')" style="width: 40px">
                      <img src="../assets/trd@2x.png" v-if="isShowTag(item,'Trending')" style="width: 67px">
                    </div>
                    <div class="tag_box">
                      <span class="new" v-if="isShowTag(item,'New')">New</span>
                      <span class="best" v-if="isShowTag(item,'Bestsellers')">Bestseller</span>
                      <span class="trd" v-if="isShowTag(item,'Trending')">Trending</span>
                    </div>
                  </div>
                </div>
                <div class="empty_box" v-else>
                  <img src="../assets/empty.png">
                </div>
              </a-skeleton>
              <div class="pagination" v-if="dataList.length>0">
                <a-pagination
                  :show-total="(total, range) => `${range[0]}-${range[1]} items, total ${total} items`"
                  show-size-changer
                  :page-size-options="['20', '40', '100']"
                  :current="queryParam.pageNum"
                  :total="total"
                  :page-size="queryParam.pageSize"
                  @change="changeSize"
                  @showSizeChange="onSizeChange"
                />
              </div>
            </div>
          </a-col>
        </a-row>
      </div>
    </content>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'
import {get, post} from '@/api'
import {
  findTopLevelParentId,
  getItemsById,
  getNamesById,
  getSeoLinkName,
  setOpenKeys,
  unSubmenus,
  findKeyByValue
} from '@/utils/utils'
import {swiper, swiperSlide} from 'vue-awesome-swiper'
import EventBus from '../router/event-bus.js'

export default {
  name: 'Products',
  components: {
    Header,
    Footer,
    swiper,
    swiperSlide
  },
  data () {
    return {
      title: '',
      menuTitle: '',
      selectNames: [],
      dataList: [],
      productList: [],
      tagsList: [],
      checkedList: [],
      menuData: [],
      spinning: false,
      priceOpen: false,
      selectedPrice: undefined,
      selectedLocation: undefined,
      priceList: [
        {
          label: '0-10',
          value: 1
        }, {
          label: '10-30',
          value: 2
        }, {
          label: '>30',
          value: 3
        },
      ],
      locationList: [],
      weightOpen: false,
      timeOpen: false,
      priceRange: undefined,
      countryRange: undefined,
      weightRange: undefined,
      timeRange: undefined,
      pageNum: 1,
      pageSize: 20,
      total: 0,
      queryParam: {
        pageNum: 1,
        pageSize: 20,
        categoryId: undefined,
        minPrice: undefined,
        maxPrice: undefined,
        minWeight: undefined,
        maxWeight: undefined,
        performanceTime: undefined,
        performanceTimeEnd: undefined,
        productName: undefined,
        orderByType: undefined,
        tagIds: [],
        locationId: undefined
      },
      swiperOption: {
        slidesPerView: 7,
        slidesPerGroup: 7,
        spaceBetween: 10,
        loop: true,
        loopFillGroupWithBlank: true,
        height: 264,
        navigation: {
          nextEl: '.button-next',
          prevEl: '.button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },
      expandedMenu: new Map(),
      expandedMenuName: new Map(),
      openKeys: [],
      selectedKeys: [],
      rootSubmenuKeys: [],
    }
  },
  watch: {
    openKeys (val) {
    },
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    },
  },
  mounted () {
    window.scrollTo(0, 0)
    this.title = window.location.href + 'Products'
    const that = this
    document.body.addEventListener('click', function (e) {
      if (e.target.closest('.slide_box')) {
        that.toDetailsDes({seoCustomerAddress: e.target.closest('.slide_box').getAttribute('data-id')})
      }
    })
    window.addEventListener('popstate', handleUrlChange)

    // 定义一个函数来处理 URL 变化
    function handleUrlChange (event) {
      that.getCategoryList()
    }
  },

  created () {
    this.queryParam.productName = this.$route.params.productName || undefined
    this.queryParam.tagIds = this.$route.query.tagId ? [this.$route.query.tagId] : []
    this.queryParam.categoryId = this.$route.query.categoryId || undefined
    EventBus.$on('customEvent', this.handleCustomEvent)
    this.getProductNewList()
    this.getCategoryList()
    this.getTagsList()
    this.getProductLocation()
  },
  beforeDestroy () {
    EventBus.$off('customEvent', this.handleCustomEvent)
  },

  methods: {
    onOpenChange (openKeys) {

    },
    //type===0只更新 this.queryParam.productName = data
    handleCustomEvent (data, type) {
      this.queryParam.productName = data
      if (type === 1) {
        this.queryParam.tagIds = []
        this.selectedKeys = []
        this.handleItemClick('', 2)
        this.menuData.forEach(item => {
          item.menuOpen = false
        })
        EventBus.$emit('event', this.queryParam.productName)
      } else if (type === 2) {
        this.handleItemClick('', 2)
      }
    },
    handleMouseDown (event, type) {
      event.preventDefault()
      if (type === 0) {
        this.priceOpen = !this.priceOpen
        this.weightOpen = false
        this.timeOpen = false
      } else if (type === 1) {
        this.weightOpen = !this.weightOpen
        this.priceOpen = false
        this.timeOpen = false
      } else if (type === 2) {
        this.timeOpen = !this.timeOpen
        this.priceOpen = false
        this.weightOpen = false
      }
    },
    handleDel () {
      this.$refs.header.delProductValue()
    },
    handleMouseLeave () {
      if (this.priceOpen || this.weightOpen || this.timeOpen) {
        this.queryParam.pageNum = 1
        this.getProductList()
      }
      this.priceOpen = false
      this.weightOpen = false
      this.timeOpen = false

    },
    handleInputClick (event, type) {
      event.target.focus()
    },
    handleInput (type) {
      if (type === 0) {
        const minPrice = this.queryParam.minPrice
        const maxPrice = this.queryParam.maxPrice
        let value
        if (minPrice && maxPrice) {
          value = `${minPrice} - ${maxPrice}`
        } else if (minPrice) {
          value = `>=${minPrice}`
        } else if (maxPrice) {
          value = `<=${maxPrice}`
        } else {
          value = undefined
        }
        this.priceRange = value ? value + '$' : value
      } else if (type === 1) {
        const minWeight = this.queryParam.minWeight
        const maxWeight = this.queryParam.maxWeight
        let value
        if (minWeight && maxWeight) {
          value = `${minWeight} - ${maxWeight}`
        } else if (minWeight) {
          value = `>=${minWeight}`
        } else if (maxWeight) {
          value = `<=${maxWeight}`
        } else {
          value = undefined
        }
        this.weightRange = value ? value + 'G' : value
      } else if (type === 2) {
        const performanceTime = this.queryParam.performanceTime
        const performanceTimeEnd = this.queryParam.performanceTimeEnd
        let value
        if (performanceTime && performanceTimeEnd) {
          value = `${performanceTime} - ${performanceTimeEnd}`
        } else if (performanceTime) {
          value = `>=${performanceTime}`
        } else if (performanceTimeEnd) {
          value = `<=${performanceTimeEnd}`
        } else {
          value = undefined
        }
        this.timeRange = value ? value + 'Day' : value
      }
    },
    handleChange1 (e, type) {
      if (type === 0) {
        this.selectedPrice = e
        this.queryParam.minPrice = e === 1 ? '0' : e === 2 ? '10' : e === 3 ? '31' : undefined
        this.queryParam.maxPrice = e === 1 ? '10' : e === 2 ? '30' : e === 3 ? undefined : undefined
        const minPrice = this.queryParam.minPrice
        const maxPrice = this.queryParam.maxPrice
        let value
        if (minPrice && maxPrice) {
          value = `${minPrice} - ${maxPrice}`
        } else if (minPrice) {
          value = `>30`
        } else {
          value = undefined
        }
        this.priceRange = value ? value + '$' : value
      } else if (type === 1) {
        this.selectedLocation = e
      }
      this.queryParam.pageNum = 1
      this.getProductList()
    },
    handleChange (value, type) {
      if (type === 0) {
        this.queryParam.minPrice = value
        this.queryParam.maxPrice = value
      } else if (type === 1) {
        this.queryParam.minWeight = value
        this.queryParam.maxWeight = value
      } else if (type === 2) {
        this.queryParam.performanceTime = value
        this.queryParam.performanceTimeEnd = value
      } else if (type === 3) {
        this.queryParam.orderByType = value
      }
      this.queryParam.pageNum = 1
      this.getProductList()
    },
    getProductNewList () {
      get('/index/product/new')
        .then(response => {
          this.productList = response.data
          this.productList.forEach(item => {
            if (!item.productTemplateImg) {
              item['productTemplateImg'] = item.productImg
            }
          })
        })
        .catch(error => {
          console.error(error)
        })

    },
    getProductLocation () {
      get('/index/product/produceLocation')
        .then(response => {
          this.locationList = response.data
          let param = this.$route.query.location || undefined
          if (param === 'united-states' && this.locationList.length > 0) {
            const resultObject = this.locationList.find(item => item.showName === 'United States')
            if (resultObject) {
              this.selectedLocation = resultObject.id
              this.queryParam.locationId = resultObject.id
              this.getProductList()
            }
          }
        }).catch(error => {
        console.error(error)
      })

    },
    getCategoryList () {
      get('/index/product/category/v2')
        .then(response => {
          this.menuData = response.data.children
          this.menuData.unshift({id: '', name: 'All', children: [], productNumber: response.data.productNumber})
          this.rootSubmenuKeys = response.data.children.map(item => item.id)
          this.queryParam.categoryId = this.queryParam.categoryId || undefined
          this.menuTitle = 'All'
          this.selectNames = [this.menuTitle]
          this.menuData.forEach(l1 => {
            this.expandedMenu.set(l1.id, [l1.id])
            this.expandedMenuName.set(l1.id, [getSeoLinkName(l1.name), `/products/category/${getSeoLinkName(l1.name)}`])
            if (l1.children) {
              l1.children.forEach(l2 => {
                this.expandedMenu.set(l2.id, [l1.id, l2.id])
                if (l2.parentId !== null) {
                  this.expandedMenuName.set(l2.id, [getSeoLinkName(l1.name), getSeoLinkName(l2.name),
                    `/products/category/${getSeoLinkName(l1.name)}/${getSeoLinkName(l2.name)}`])
                }
                if (l2.children) {
                  l2.children.forEach(l3 => {
                    this.expandedMenu.set(l3.id, [l1.id, l2.id, l3.id])
                    this.expandedMenuName.set(l3.id, [getSeoLinkName(l1.name), getSeoLinkName(l2.name), getSeoLinkName(l3.name),
                      `/products/category/${getSeoLinkName(l1.name)}/${getSeoLinkName(l2.name)}/${getSeoLinkName(l3.name)}`])
                  })
                }
              })
            }
          })
          const hrefUrl = new URL(location.href)
          let selectId = findKeyByValue(this.expandedMenuName, hrefUrl.pathname)
          this.queryParam.categoryId = selectId
          const topLevelParentId = findTopLevelParentId(this.menuData, this.queryParam.categoryId)
          this.menuData.forEach(l1 => {
            l1['menuOpen'] = topLevelParentId === l1.id
            l1['grade'] = 1
            if (l1.id === this.queryParam.categoryId) {
              this.menuTitle = l1.name
              this.selectNames = [l1.name]
              this.openKeys = [l1.id]
            }
            if (l1.children) {
              l1.children.forEach(l2 => {
                l2['submenuOpen'] = this.queryParam.categoryId === l2.id
                l2['grade'] = 2
                if (l2.id === this.queryParam.categoryId) {
                  this.menuTitle = l2.name
                  if (l2.parentId !== null) {
                    this.selectNames = [l1.name, l2.name]
                  }
                  this.openKeys = [l1.id, l2.id]
                }
                if (l2.children) {
                  l2.children.forEach(l3 => {
                    l3['submenuOpen'] = this.queryParam.categoryId === l3.id
                    l3['grade'] = 3
                    if (l3.id === this.queryParam.categoryId) {
                      this.menuTitle = l3.name
                      this.selectNames = [l1.name, l2.name, l3.name]
                      this.openKeys = [l1.id, l2.id, l3.id]
                    }
                  })
                }
              })
            }
          })
          let menuList = getItemsById(this.menuData, topLevelParentId)
          this.openKeys = setOpenKeys(menuList)
          this.selectedKeys = [String(this.queryParam.categoryId || '')]
          this.selectNames.unshift('Products')
          this.queryParam.pageNum = 1
          this.getProductList(0)

        })
        .catch(error => {
          console.error(error)
        })

    },
    getTagsList () {
      get('/index/product/tags')
        .then(response => {
          this.tagsList = response.data.children
        })
        .catch(error => {
          console.error(error)
        })

    },
    getProductList (type) {
      this.spinning = true
      post('/index/product/search', this.queryParam)
        .then(response => {
          this.dataList = response.data.list
          this.total = response.data.total
          this.dataList.forEach(item => {
            if (!item.productTemplateImg) {
              item['productTemplateImg'] = item.productImg
            }
            const {specColorOptionVOS, specOptionsVOS} = item
            const spec = specColorOptionVOS.map(({
              colorOptionVOList,
              specsName
            }) => `${colorOptionVOList.length} ${specsName}`).join(' ')
            const spec1 = specOptionsVOS.map(({
              optionNames,
              specsName
            }) => `${optionNames.length} ${specsName}`).join(' ')
            item.spec = `${spec} ${' '.repeat(3)} ${spec1}`
          })
          this.spinning = false
          if (type !== 0) {
            this.onScrollTo()
          }

        })
        .catch(error => {
          this.spinning = false
          console.error(error)
        })

    },
    onScrollTo () {
      const element = document.getElementsByClassName('product_box')[0]
      let height = 96
      const rect = element.getBoundingClientRect()
      const scrollOptions = {
        left: rect.left + window.scrollX,
        top: rect.top + window.scrollY - height,
        behavior: 'smooth'
      }
      window.scrollTo(scrollOptions)
    },
    isShowTag (item, name) {
      const hasIsName = (item.tagList && item.tagList.some(item => item.showName && item.showName.toLowerCase() === name.toLowerCase())) || false
      return hasIsName
    },
    onSizeChange (current, size) {
      this.queryParam.pageNum = 1
      this.queryParam.pageSize = size
      this.getProductList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getProductList()
    },
    checkBoxOnChange (e) {
      this.queryParam.categoryId = undefined
      this.openKeys = []
      this.selectedKeys = [String('')]
      this.menuData.forEach(item => {
        item.menuOpen = false
      })
      this.menuTitle = 'All'
      this.selectNames = ['Products', this.menuTitle]
      if (e.target.checked) {
        this.queryParam.tagIds.push(e.target.value)
      } else {
        this.queryParam.tagIds = this.queryParam.tagIds.filter(item => e.target.value !== item)
      }
      this.queryParam.pageNum = 1
      this.setNewUrl('')
      this.getProductList()
    },
    handleItemClick (key, isUnfold, level, menu) {
      let menuList = getItemsById(this.menuData, key)
      if (isUnfold === 0) {
        this.openKeys = this.openKeys.includes(key) ? [] : setOpenKeys(menuList)
      } else {
        this.setNewUrl(key)
        this.menuData.forEach(l1 => {
          unSubmenus(l1.children)
        })
        this.selectedKeys = [String(key)]
        if (key === '') {
          this.openKeys = []
        }
        if (isUnfold === 2) {
          this.menuData.forEach(item => item.menuOpen = false)
        }
        this.selectNames = getNamesById(this.menuData, key)
        this.menuTitle = menuList[0].name
        this.selectNames.unshift('Products')
        this.queryParam.pageNum = 1
        this.queryParam.categoryId = key
        this.getProductList(key)
        if (level !== 2) menu && menu.children.forEach(item => item.submenuOpen = false)
        menu && menu.children.forEach(item => {
          item.submenuOpen = key === item.id
        })
      }
      if (isUnfold === 0 || key === '') {
        this.menuData.forEach(item => {
          item.menuOpen = item.id === key ? !item.menuOpen : false
        })
      }
      EventBus.$emit('animationEvent')
    },
    setNewUrl (key) {
      let names = this.expandedMenuName.get(key)
      let namesCopy = names.slice(0, -1)
      let urlParams = namesCopy.join('/')
      const href = new URL(location.origin)
      const newUrl = urlParams === 'all' ? `${href}products` : `${href}products/category/${urlParams}`
      window.history.pushState({}, '', newUrl)
    },
    toDetailsDes (item) {
      window.open(`/products/${item.seoCustomerAddress}`, '_blank')
    },
  },
}
</script>
<style scoped lang="less">

.content {
  display: flex;
  flex-direction: column;
  margin-top: 96px;

  //菜单打开状态/\箭头左/
  /deep/ .ant-menu-submenu-open.ant-menu-submenu-inline > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before {
    width: 8px;
    display: none;
    transform: rotate(45deg) translateX(3.6px);
  }

  //菜单打开状态/\箭头右\
  /deep/ .ant-menu-submenu-open.ant-menu-submenu-inline > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after {
    width: 8px;
    display: none;
    transform: rotate(-45deg) translateX(-3.6px);
  }

  //菜单收起状态\/箭头左\
  /deep/ .ant-menu-inline-collapsed .ant-menu-submenu-arrow::before, /deep/ .ant-menu-submenu-inline .ant-menu-submenu-arrow::before {
    width: 8px;
    display: none;
    transform: rotate(-45deg) translateX(3.6px);
  }

  //菜单收起状态\/箭头右/
  /deep/ .ant-menu-inline-collapsed .ant-menu-submenu-arrow::after, /deep/ .ant-menu-submenu-inline .ant-menu-submenu-arrow::after {
    width: 8px;
    display: none;
    transform: rotate(45deg) translateX(-3.6px);
  }

  /deep/ .ant-menu-inline, .ant-menu-vertical, .ant-menu-vertical-left {
    border-right: 1px solid transparent;
  }

  /deep/ .ant-checkbox-wrapper {
    font-size: 16px;
    color: #666666;
  }

  /deep/ .ant-menu-item {
    font-weight: 200;
  }

  /deep/ .ant-menu-item-selected {
    font-weight: 400;
  }

  .arrivals_box {
    font-family: Roboto;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 424px;
    background: #F8FAFC;

    .title {
      line-height: 35px;
      font-weight: 500;
      font-size: 45px;
      margin-top: 54px;
      color: #222222;
    }

    .des {
      font-weight: 400;
      font-size: 16px;
      line-height: 16px;
      color: #222222;
      margin-top: 11px;
    }

    .swiper_box {
      width: 1500px;
      height: 220px;
      display: flex;
      position: relative;
    }

    .button-prev {
      position: absolute;
      top: calc((100% - 55px) / 2);
      opacity: 0.6;
      left: 20px;
      transition: all ease 0.3s;
    }

    .button-prev:hover {
      opacity: 1;
    }

    .button-next {
      position: absolute;
      top: calc((100% - 55px) / 2);
      opacity: 0.6;
      right: 20px;
      transition: all ease 0.3s;
    }

    .button-next:hover {
      opacity: 1;
    }

    .swiper-container {
      width: 1340px;
      position: absolute;
      top: 50%;
      left: 50%;
      display: flex;
      transform: translate(-50%, -50%);

      .slide_box {
        width: 169px;
        cursor: pointer;
        display: flex;
        position: relative;
        flex-direction: column;
        margin-left: 10px;
        border-radius: 6px;

        .img_box:hover {
          border: 2px solid #343183;
          box-shadow: 0px 0px 14px 0px rgba(0, 0, 0, 0.35);
        }

        .img_box {
          width: 169px;
          height: 169px;
          position: relative;
          overflow: hidden;
          border-radius: 50%;
          border: 2px solid transparent;
          transition: all ease 0.3s;
          margin-top: 45px;

          .img1 {
            width: 100%;
            height: 100%;
            opacity: 1;
            position: absolute;
            border-radius: 3px;
            top: 0;
            transition: all ease 0.6s;
          }

          .img2 {
            width: 100%;
            height: 100%;
            opacity: 0;
            border-radius: 3px;
            position: absolute;
            top: 0;
            transition: all ease 0.6s;
          }

        }

        .name {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: normal;
          -webkit-line-clamp: 2;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          word-wrap: break-word;
          margin: 10px;
          font-family: Roboto;
          text-align: center;
          font-weight: 500;
          font-size: 18px;
          line-height: 23px;
          color: #222222;
        }

        .price {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: normal;
          -webkit-line-clamp: 1;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          word-wrap: break-word;
          margin: 0 6px;
          font-weight: 400;
          font-size: 14px;
          color: #666666;
        }

        .label {
          width: 64px;
          height: 30px;
          border-image: linear-gradient(0deg, #588ABD, #C8DFF9) 10 10;
          border-radius: 6px;
          font-weight: bold;
          text-align: center;
          position: absolute;
          top: 5px;
          left: 5px;
          font-size: 16px;
          color: #FFFFFF;
          line-height: 30px;
        }
      }

      .slide_box:hover .img_box .img1 {
        opacity: 0;
        transform: scale(1.1);
      }

      .slide_box:hover .img_box .img2 {
        opacity: 1;
        transform: scale(1.1);
      }


    }
  }

  .product_box {
    font-family: Roboto;
    padding: 46px 190px 100px 190px;
    background: #FFFFFF;

    /deep/ .ant-pagination-item-active {
      font-weight: 500;
      background: #343183;
    }

    /deep/ .ant-pagination-item-active a {
      color: #FFFFFF;
    }

    .product_view {
      display: flex;
      flex-direction: column;
      margin-left: 10px;

      .title {
        font-family: Roboto;
        font-weight: 500;
        font-size: 28px;
        color: #222222;
        line-height: 40px;
      }

      .label_box {
        width: 1185px;
        display: flex;
        flex-direction: row;
        height: 30px;
        align-items: center;
        justify-content: space-between;

        .label {
          display: flex;
          flex-direction: row;
          max-width: 800px;
          line-height: 36px;
          font-family: Roboto;
          font-weight: 400;
          font-size: 18px;
          color: #485256;
        }

        .checkbox_group {
          flex-wrap: wrap;
          display: flex;
        }
      }

      .filtrate_box {
        width: 1187px;
        display: flex;
        margin-top: 8px;
        align-items: center;
        justify-content: space-between;
        border-radius: 10px;
        padding-right: 19px;

        .select_view {
          width: 150px;
          cursor: pointer;
          padding: 20px 8px;
          display: flex;
        }

        .check_icon {
          display: none;
        }
      }

      .empty_box {
        width: 1210px;
        margin-top: 7%;
        display: flex;
        align-items: center;
        justify-content: center
      }

      .product_list {
        width: 1210px;
        margin-bottom: 30px;
        display: flex;
        flex-wrap: wrap;
        position: relative;

        .list_box:hover {
          background: #F8FAFC;
          border-radius: 4px;
        }

        .list_box {
          width: 220px;
          height: 325px;
          cursor: pointer;
          display: flex;
          position: relative;
          margin-top: 20px;
          margin-right: 21px;
          flex-direction: column;
          background: #FFFFFF;

          .img_box {
            width: 220px;
            height: 220px;
            position: relative;
            overflow: hidden;
            border-radius: 3px;
            transition: all ease 0.3s;

            .img1 {
              width: 100%;
              height: 100%;
              opacity: 1;
              position: absolute;
              border-radius: 3px;
              top: 0;
              transition: all ease 0.6s;
            }

            .img2 {
              width: 100%;
              height: 100%;
              opacity: 0;
              border-radius: 3px;
              position: absolute;
              top: 0;
              transition: all ease 0.6s;
            }

          }

          .name {
            width: 220px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
            -webkit-line-clamp: 1;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            word-wrap: break-word;
            margin: 16px 6px 12px 6px;
            font-family: Roboto;
            font-weight: 500;
            font-size: 18px;
            color: #333333;
            line-height: 18px;
          }

          .price {
            width: 220px;
            font-family: Roboto;
            color: #343183;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
            -webkit-line-clamp: 1;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            word-wrap: break-word;
            margin: 0 6px;
            font-weight: 400;
            line-height: 18px;
            font-size: 18px;
          }

          .size {
            width: 220px;
            font-family: Roboto;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
            -webkit-line-clamp: 1;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            word-wrap: break-word;
            font-weight: 300;
            font-size: 14px;
            line-height: 14px;
            margin-top: 11px;
            margin-left: 6px;
            margin-right: 6px;
            color: #485256;
          }

          .tag_box {
            display: flex;
            position: absolute;
            height: 19px;
            top: 10px;
            left: 6px;
            font-family: Roboto;
            font-weight: 400;

            .best {
              height: 19px;
              background: #FFDEE0;
              border-radius: 3px;
              padding: 0 5px;
              font-size: 14px;
              line-height: 17px;
              margin-right: 3px;
              text-align: center;
              border: 1px solid #FF000C;
              color: #FF000C;
            }

            .new {
              height: 19px;
              background: #FFE0C5;
              border-radius: 3px;
              padding: 0 5px;
              font-size: 14px;
              line-height: 17px;
              margin-right: 3px;
              text-align: center;
              border: 1px solid #F6790F;
              color: #F6923D;
            }

            .trd {
              height: 19px;
              background: #E2E1FF;
              border-radius: 3px;
              padding: 0 5px;
              font-size: 14px;
              line-height: 17px;
              text-align: center;
              border: 1px solid #343183;
              color: #343183;
            }
          }
        }

        .list_box:hover .img_box .img1 {
          opacity: 0;
          transform: scale(1.1);
        }

        .list_box:hover .img_box .img2 {
          opacity: 1;
          transform: scale(1.1);
        }

      }

      .pagination {
        width: 1185px;
        display: flex;
        margin-top: 30px;
        justify-content: end;

        /deep/ .ant-pagination {
          font-family: Roboto;
          font-weight: 300;
          font-size: 16px;
          color: #485256;
        }

        /deep/ .ant-select {
          font-family: Roboto;
          font-weight: 300;
          font-size: 16px;
          color: #485256;
        }
      }

    }

  }
}

</style>



// WEBPACK FOOTER //
// src/views/Products.vue